import React, { useEffect, useState, useRef } from "react";
import Sidebar from "../../component/Sidebar/SideBar";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import ListingDataTables from "../../component/ListingDataTable";
import { toast } from "react-toastify";
import getVendors from "../../services/packages/getVendors";
import addVendor from "../../services/packages/addVendor";
import toggleVendor from "../../services/packages/toggleVendor";

const VendorManagement = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const prevVendorsRef = useRef([]);
  const [addFormOpen, setAddFormOpen] = useState(false);
  const [newVendorName, setNewVendorName] = useState("");
  const [newVendorKey, setNewVendorKey] = useState("");
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState(false);

  const fetchVendors = async () => {
    try {
      setLoading(true);
      const res = await getVendors();
      const data = res?.data || [];
      setVendors(data);
      prevVendorsRef.current = data;
    } catch (error) {
      console.error("error fetching vendors:", error);
      toast.error("Failed to fetch vendors");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  const handleToggle = async (row) => {
  try {

    // Optimistic UI update
    const updated = vendors.map((v) =>
      v._id === row._id ? { ...v, isActive: !v.isActive } : v
    );
    setVendors(updated);

    // Call toggle service (comment out if backend isn’t ready yet)
    await toggleVendor(row._id);

    toast.success(`${row.name} ${!row.isActive ? "enabled" : "disabled"}`);
  } catch (err) {
    // Revert if failed
    setVendors(prevVendorsRef.current);
    console.error("Toggle error:", err);
    toast.error("Failed to update vendor status");
  }
};
 const handleAddVendor = async () => {
  if (!newVendorName) {
    setAddError(true);
    return;
  }

  try {
    setAddLoading(true);

    const payload = {
      name: newVendorName,
      key: newVendorKey || newVendorName.toLowerCase().replace(/\s+/g, "_"),
      isActive: true,
    };

    console.log("Adding vendor:", payload);

    // ✅ Use addVendor service (API call)
    const response = await addVendor(payload);
    const savedVendor = response?.data || payload;
    setVendors((prev) => [savedVendor, ...prev]);

    // For now, simulate success
    setAddFormOpen(false);
    toast.success("Vendor added successfully");
  } catch (e) {
    console.error("Add vendor error:", e);
    toast.error("Failed to add vendor");
  } finally {
    setAddLoading(false);
  }
};

  const columns = [
    {
      name: <span className="dataTable-text">Vendor</span>,
      selector: (row) => row.name,
      cell: (row) => <div className="text-start column-text">{row.name}</div>,
      sortable: true,
      width: "300px",
    },
    {
     name: <span className="dataTable-text">Vendor Key</span>,
     selector: (row) => row.key,
     cell: (row) => <div className="text-start column-text">{row.key}</div>,
     sortable: true,
     width: "300px",
   },
    {
      name: <span className="dataTable-text">Packages</span>,
      selector: (row) => row.isActive,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <label className="switch">
            <input
              type="checkbox"
              checked={!!row.isActive}
              onChange={() => handleToggle(row)}
            />
            <span className="slider round"></span>
          </label>
        </div>
      ),
      width: "120px",
    },
  ];

  return (
    <Sidebar>
      <Container>
        <Row>
          <Col md={12} className="text-start package-h2 p-0">
            <h2>Vendor Management</h2>
          </Col>
          <Col md={12} className="script-box text-start p-4 mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div></div>
              <div>
                <button
                  className="btn-add-new btn-add-new-font"
                  onClick={() => {
                    setNewVendorName("");
                    setNewVendorKey("");
                    setAddFormOpen((s) => !s);
                    setAddError(false);
                  }}
                >
                  + Add Vendor
                </button>
              </div>
            </div>

            {addFormOpen && (
              <div className="add-vendor-form mb-3 p-3 border rounded">
                <Row className="g-2 align-items-end">
                  <Col md={5} xs={12}>
                    <label className="form-label">Vendor Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newVendorName}
                      onChange={(e) => setNewVendorName(e.target.value)}
                      placeholder="Enter vendor name"
                    />
                    {addError && !newVendorName && (
                      <div className="text-danger mt-1">Enter vendor name</div>
                    )}
                  </Col>
                  <Col md={4} xs={12}>
                    <label className="form-label">Key</label>
                    <input
                      type="text"
                      className="form-control"
                      value={newVendorKey}
                      onChange={(e) => setNewVendorKey(e.target.value)}
                      placeholder="vendor_key"
                    />
                  </Col>
                  <Col md={3} xs={12} className="text-end">
                    <div className="d-flex justify-content-end gap-2">
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => setAddFormOpen(false)}
                        disabled={addLoading}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleAddVendor}
                        disabled={addLoading}
                      >
                        {addLoading ? "Adding..." : "Add"}
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            <div>
              <ListingDataTables
                columns={columns}
                data={vendors}
                loading={loading}
                totalRows={vendors?.length || 0}
                perPage={20}
                onChangePage={() => {}}
                onChangeRowsPerPage={() => {}}
                handleSort={() => {}}
                handleSelectedRowsChange={() => {}}
                toggledClearRows={false}
              />
            </div>
          </Col>
        </Row>

        <style>{`
          .switch { position: relative; display: inline-block; width: 46px; height: 26px; }
          .switch input { opacity: 0; width: 0; height: 0; }
          .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: .4s; border-radius: 26px; }
          .slider:before { position: absolute; content: ""; height: 20px; width: 20px; left: 3px; bottom: 3px; background-color: white; transition: .4s; border-radius: 50%; }
          input:checked + .slider { background-color: #2196F3; }
          input:checked + .slider:before { transform: translateX(20px); }
        `}</style>
      </Container>
    </Sidebar>
  );
};

export default VendorManagement;
